import { theme } from "../../utils/theme";

export const styles = {
  body: {
    alignItems: "start",
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
  },
  bodyText: {
    color: theme.palette.grays[700],
    fontSize: { xs: theme.typography.body, md: theme.typography.h4 },
    fontWeight: 400,
    mb: { xs: 4, md: 0 },
    mt: { xs: 6, md: 6 },
    textAlign: { xs: "center", md: "center" },
    textTransform: "none",
  },
  footerText: {
    color: theme.palette.accent.main,
    fontSize: {
      xs: theme.typography.fontSize * 1,
      md: theme.typography.fontSize * 1,
    },
    mt: { xs: 4, md: 4 },
    textAlign: { xs: "end", md: "end" },
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  item: {
    alignItems: { xs: "center", md: "center" },
    display: "flex",
    minHeight: { xs: 280, sm: 280, md: 320 },
    px: { xs: 2, md: 30 },
    py: { xs: 8, md: 8 },
  },
  itemBody: {
    color: theme.palette.grays[700],
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.body,
    },
    textAlign: { xs: "center", md: "center" },
    width: { xs: "70%", md: "100%" },
  },
  itemContent: {
    alignItems: { xs: "start", md: "start" },
    display: "flex",
    flexDirection: { xs: "column", md: "column" },
    gap: 3,
    justifyContent: { xs: "start", md: "start" },

  },
  itemHeader: {
    color: theme.palette.secondary.main,
    fontSize: {
      xs: theme.typography.h3,
      md: theme.typography.h3,
    },
    fontWeight: 700,
    letterSpacing: 1.2,
    lineHeight: 1.1,
    textAlign: { xs: "center", md: "center" },
    width: { xs: "74%", md: "100%" },
  },
  margin: {
    display: "flex",
    margin: 1,
  },
  root: {
    mb: -12,
    // mt: { xs: 0, md: -12 },
  },
};
